module.exports = __webpack_public_path__ + "static/img/2018.1c5c6db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2018.jpg
// module id = 308
// module chunks = 0